import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { IRide } from './types';
import * as VehiclesDataState from '../../store/recoil/vehiclesData';
import { localForageStore } from '../../store/localForageStore';
import { IVehicleData } from '../Vehicles/types';
import {
  activeLastRideIdAtom,
  activeRideNumberAtom,
  actualPlayPositionAtom,
} from './RidePlayerState';
import { isOnlinePanelOpenAtom } from '../OnlinePanel/OnlinePanelState';

interface IRidePlayerDebug {
  rides: IRide[];
}

function RidePlayerDebugPanel(props: IRidePlayerDebug): JSX.Element {
  const positionIndex = useRecoilValue<number>(actualPlayPositionAtom);
  const activeRideNumber = useRecoilValue<number>(activeRideNumberAtom);
  const activeLastRideId = useRecoilValue(activeLastRideIdAtom);
  const [showDebugInfo, setShowDebugInfo] = React.useState<boolean>(false);
  const isOnlinePanelOpen = useRecoilValue<number | false>(isOnlinePanelOpenAtom);
  const vehicleData = useRecoilValue<IVehicleData | null>(
    VehiclesDataState.vehicleDataByIdSelector(isOnlinePanelOpen)
  );
  const [rides, setRides] = React.useState<string>('');

  const handleShowDebugInfo = () => {
    setShowDebugInfo(!showDebugInfo);
  };

  const getRideIds = async () => {
    const rideIds: string[] | null = await localForageStore.getItem('rides');
    if (rideIds) {
      const ridesString = rideIds.join('\n');
      setRides(ridesString);
      return ridesString;
    }
    return '';
  };

  React.useEffect(() => {
    getRideIds();
  }, []);

  const handleUpdateRides = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const ridesTextarea: HTMLElement | null = document.getElementById('rides');
    if (ridesTextarea) {
      const ridesString = (ridesTextarea as HTMLTextAreaElement).value;
      await localForageStore.setItem('rides', ridesString.split('\n'));
      setRides(ridesString);
      window.location.reload();
    }
  };

  return (
    <div
      className="player-debug"
      style={{
        position: 'absolute',
        top: '8px',
        right: '50px',
        background: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '8px',
        padding: '4px',
        fontSize: '12px',
        zIndex: 9999,
      }}
    >
      {props.rides && props.rides[activeRideNumber - 1] && (
        <p style={{ marginBottom: 0 }}>
          Hi! I am your player debugger :)
          <br />
          {`${activeRideNumber} | ${positionIndex} | ${
            props.rides[activeRideNumber - 1].positions[positionIndex]?.type
          }`}
          {' | '}
          <a href="#" onClick={handleShowDebugInfo} title="Toggle debug info">
            Show debug data
          </a>
        </p>
      )}
      {showDebugInfo && (
        <div
          className="b-widget-grid b-widget-grid--rounded b-widget-grid--static"
          style={{ maxHeight: '300px', overflowY: 'auto' }}
        >
          <h4>Ride ids</h4>
          <textarea rows={5} id="rides">
            {rides}
          </textarea>
          <br />
          <button type="button" onClick={handleUpdateRides}>
            Update rides
          </button>
          <h4>Debug info</h4>
          <table>
            <tr>
              <td>
                <p>
                  Ride id
                  <br />
                  {activeLastRideId}
                </p>
              </td>
              <td>
                <p>
                  Position index
                  <br />
                  {positionIndex}
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p>Ride data:</p>
                <textarea rows={5} style={{ width: '100%' }}>
                  {JSON.stringify(props.rides)}
                </textarea>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p>Vehicle data:</p>
                <textarea rows={5} style={{ width: '100%' }}>
                  {JSON.stringify(vehicleData)}
                </textarea>
              </td>
            </tr>
          </table>
        </div>
      )}
    </div>
  );
}

export default RidePlayerDebugPanel;
